export default __webpack_public_path__ + "images/640e9cdd2067e417878389306ec93e76-language_small.webp";